/** Inline SVGs for Marketing email “feature row” icon slot (Lucide-style strokes). */
const svgOpen =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">'
const svgClose = '</svg>'

export type FeatureRowIconChoice = {
  id: string
  label: string
  /** Full <svg>…</svg> element to inject into `.mt-email-tpl__promo-icon`. */
  svg: string
}

export const FEATURE_ROW_ICON_CHOICES: readonly FeatureRowIconChoice[] = [
  {
    id: 'sparkle',
    label: 'Sparkle',
    svg: `${svgOpen}<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>${svgClose}`,
  },
  {
    id: 'gift',
    label: 'Gift',
    svg: `${svgOpen}<path d="M20 12v10H4V12"/><path d="M22 7H2v5h20z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>${svgClose}`,
  },
  {
    id: 'people',
    label: 'People',
    svg: `${svgOpen}<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>${svgClose}`,
  },
  {
    id: 'document',
    label: 'Document',
    svg: `${svgOpen}<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/>${svgClose}`,
  },
  {
    id: 'calendar',
    label: 'Calendar',
    svg: `${svgOpen}<path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>${svgClose}`,
  },
  {
    id: 'heart',
    label: 'Heart',
    svg: `${svgOpen}<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>${svgClose}`,
  },
  {
    id: 'phone',
    label: 'Phone',
    svg: `${svgOpen}<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>${svgClose}`,
  },
  {
    id: 'mail',
    label: 'Mail',
    svg: `${svgOpen}<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>${svgClose}`,
  },
  {
    id: 'check',
    label: 'Check',
    svg: `${svgOpen}<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>${svgClose}`,
  },
  {
    id: 'clock',
    label: 'Clock',
    svg: `${svgOpen}<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>${svgClose}`,
  },
  {
    id: 'mapPin',
    label: 'Location',
    svg: `${svgOpen}<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>${svgClose}`,
  },
  {
    id: 'shield',
    label: 'Shield',
    svg: `${svgOpen}<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>${svgClose}`,
  },
  {
    id: 'award',
    label: 'Award',
    svg: `${svgOpen}<circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>${svgClose}`,
  },
  {
    id: 'creditCard',
    label: 'Payment',
    svg: `${svgOpen}<rect width="20" height="14" x="2" y="5" rx="2"/><path d="M2 10h20"/>${svgClose}`,
  },
  {
    id: 'bell',
    label: 'Reminder',
    svg: `${svgOpen}<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>${svgClose}`,
  },
  {
    id: 'smile',
    label: 'Smile',
    svg: `${svgOpen}<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><path d="M9 9h.01"/><path d="M15 9h.01"/>${svgClose}`,
  },
  {
    id: 'percent',
    label: 'Discount',
    svg: `${svgOpen}<line x1="19" x2="5" y1="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>${svgClose}`,
  },
  {
    id: 'clipboard',
    label: 'Clipboard',
    svg: `${svgOpen}<rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>${svgClose}`,
  },
  {
    id: 'megaphone',
    label: 'Announce',
    svg: `${svgOpen}<path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>${svgClose}`,
  },
  {
    id: 'leaf',
    label: 'Wellness',
    svg: `${svgOpen}<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>${svgClose}`,
  },
  {
    id: 'pill',
    label: 'Health',
    svg: `${svgOpen}<path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/>${svgClose}`,
  },
  {
    id: 'activity',
    label: 'Activity',
    svg: `${svgOpen}<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>${svgClose}`,
  },
] as const

/** Default icon embedded in {@link TEMPLATE_EMAIL_SNIPPETS.featureRow}. */
export const FEATURE_ROW_DEFAULT_SVG = FEATURE_ROW_ICON_CHOICES[0].svg

/** Matches `--blue-500` in `App.css` when no custom color is set on the icon cell. */
export const FEATURE_ROW_ICON_DEFAULT_HEX = '#185dd8'

/** Preset colors for the feature-row icon (stroke + border use the same hex). */
export const FEATURE_ROW_ICON_COLOR_SWATCHES = [
  FEATURE_ROW_ICON_DEFAULT_HEX,
  '#3b82f6',
  '#6366f1',
  '#0d9488',
  '#059669',
  '#ca8a04',
  '#ea580c',
  '#dc2626',
  '#db2777',
  '#7c3aed',
  '#64748b',
  '#0f172a',
] as const

export function normalizeFeatureRowIconHex(input: string): string {
  let h = input.trim()
  if (!h.startsWith('#')) h = `#${h}`
  if (/^#[0-9a-fA-F]{3}$/.test(h)) {
    const [, r, g, b] = h.split('')
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
  }
  if (/^#[0-9a-fA-F]{6}$/.test(h)) return h.toLowerCase()
  return FEATURE_ROW_ICON_DEFAULT_HEX
}

function rgbToHex(r: number, g: number, b: number): string {
  const x = (n: number): string =>
    Math.max(0, Math.min(255, Math.round(n)))
      .toString(16)
      .padStart(2, '0')
  return `#${x(r)}${x(g)}${x(b)}`
}

/** Read custom color from the icon cell, or the default brand blue. */
export function readFeatureRowIconHex(el: HTMLElement): string {
  const d = el.getAttribute('data-feature-icon-color')
  if (d) return normalizeFeatureRowIconHex(d)
  const c = el.style.color?.trim()
  if (c) {
    if (c.startsWith('#')) return normalizeFeatureRowIconHex(c)
    const m = c.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
    if (m) {
      return rgbToHex(Number(m[1]), Number(m[2]), Number(m[3]))
    }
  }
  return FEATURE_ROW_ICON_DEFAULT_HEX
}

/** Set icon stroke (`color`) and border to the same hex (persisted on the cell). */
export function applyLinkedFeatureIconColors(
  el: HTMLElement,
  hex: string,
): void {
  const h = normalizeFeatureRowIconHex(hex)
  el.style.color = h
  el.style.borderColor = h
  el.setAttribute('data-feature-icon-color', h)
}

export function clearLinkedFeatureIconColors(el: HTMLElement): void {
  el.style.removeProperty('color')
  el.style.removeProperty('border-color')
  el.removeAttribute('data-feature-icon-color')
}
